module.exports = __webpack_public_path__ + "img/1.631ab81e.png";